import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

export default function Skeleton({ children, height, isLoading, width }) {
  const content = useRef(null);
  const [childrenHeight, setChildrenHeight] = useState(
    /** @type {number} childrenHeight - The height of the React Children */ 0
  );

  useEffect(() => {
    let isMounted = true;

    if (content) {
      if (isMounted) setChildrenHeight(content.current.clientHeight);
    }

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <>
      {isLoading && (
        <div
          className={clsx('animate-pulse bg-whisper')}
          style={{ height: height || childrenHeight, width: width || 'auto' }}
        />
      )}
      <div
        className={clsx('w-full sm:w-auto', {
          hidden: isLoading
        })}
        ref={content}
      >
        {children}
      </div>
    </>
  );
}

Skeleton.propTypes = {
  children: PropTypes.node,
  height: PropTypes.number,
  isLoading: PropTypes.bool,
  width: PropTypes.number
};

Skeleton.defaultProps = {
  children: null,
  height: undefined,
  isLoading: true,
  width: undefined
};
